import React from 'react';
import css from './AdminPageClubsOffers.css';
import EditForm from './EditForm';
import AdminHOC from '../AdminPanelsPage/AdminHOC';
import { SectionOurPartners } from '../LandingPage/sectionsForClubs';
import { createResourceLocatorString } from '../../util/routes';
import routeConfiguration from '../../routeConfiguration';
import AdminActionsNav from '../AdminPanelsPage/AdminActionsNav';

const Panel = ({
    currentUser,
    showList,
    handleAdminAction,
    goBack,
    showForm,
    handleSubmit,
    initialValues,
    action,
    history,
}) => (
    <>
        <AdminActionsNav
            handleAdding={() => handleAdminAction('add')}
            handleWatchList={() =>
                history.push(createResourceLocatorString('ForClubs', routeConfiguration()))
            }
        />
        {showList && (
            <SectionOurPartners handleAdminAction={handleAdminAction} currentUser={currentUser} />
        )}
        {showForm && (
            <p type="button" onClick={goBack} className={css.backButton}>
                Zurück
            </p>
        )}
        {showForm && (
            <EditForm onSubmit={handleSubmit} initialValues={initialValues} action={action} />
        )}
    </>
);

export default AdminHOC(Panel);
